import { useState } from "react";
import Calendar from "../Calendar.jsx";
import EventsTable from "../events/EventsTable.jsx";
import { FiArrowUpRight, FiPlusCircle } from "react-icons/fi";
import { Link } from "react-router-dom";
import CalendarHeader from "../CalendarHeader.jsx";
import Spinner from "../ui/Spinner.jsx";
import dayjs from "dayjs";
import { UseEvents } from "../events/useEvents.js";
import GoldAd from "../features/sponsors/GoldAd.jsx";
import Heading from "../ui/Heading.jsx";

function Index({
                   selectedCountry,
                   setSelectedCountry,
                   selectedCity,
                   setSelectedCity,
               })
{
    const [activeView, setActiveView] = useState("list");

    const { isLoading, events, error } = UseEvents({
        country: selectedCountry,
        city: selectedCity || null,
    });

    const today = dayjs().startOf("day");
    const upcomingEvents = events?.filter(
        (event) =>
            dayjs(event.startDatetime).isSame(today, "day") ||
            dayjs(event.startDatetime).isAfter(today)
    );

    if (isLoading) return <Spinner />;
    if (error) return <p className="text-red-500">Error loading events: {error.message}</p>;

    return (
        <div className="relative flex flex-col items-center justify-center">
            
            {/* Insert site description text here */}
            <div className="max-w-xl text-center mt-12 mb-8 px-4 text-gray-700 leading-relaxed">
                <p>
                    We round up the best queer dance parties and hook you up with everything you need to know to party smarter. 
                    Tickets, safety tips, and where to find your cutest outfits. One website. No time wasting.
                </p>
                

                <p className="mt-4 font-semibold text-pink-600 mb-10">
                    UnicorNation — for party lovers, by party lovers.
                </p>
                
                <GoldAd
                    sponsorId="truethai-mel"
                    selectedCountry={selectedCountry}
                    selectedCity={selectedCity}
                />
            </div>
            <Heading className="text-center font-bold mb-4">
                Party Calendar
            </Heading>
            <CalendarHeader
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                activeView={activeView}           // pass activeView
                setActiveView={setActiveView}     // pass setter
            />

            {activeView === "calendar" ? (
                <div
                    className="w-full {/*bg-pink-50*/}"
                    style={{ minHeight: "600px" }}
                >
                    <div className="mx-auto max-w-6xl p-2 pt-5">
                        <Calendar events={events} />
                    </div>
                </div>
            ) : (
                <div
                    className="w-full {/*bg-pink-50*/}"
                    style={{ minHeight: "800px" }}
                >
                    <div className="mx-auto max-w-6xl p-2 pt-5">
                        <EventsTable events={upcomingEvents} />
                    </div>
                </div>
            )}

            {/* Feedback Button */}
            <div className="w-full flex justify-center mt-2 mb-4 p-5">
                <Link to="/contact-us" className="suggest-party-link">
                    <FiPlusCircle className="suggest-party-icon" aria-hidden="true" />
                    <span><span className="suggest-party-heading">Know a party we&apos;re missing?</span>
                        <span className="suggest-party-caption">Let us know</span>
                    </span>
                    <FiArrowUpRight className="suggest-party-arrow" aria-hidden="true" />
                </Link>
            </div>
        </div>
    );
}

export default Index;
